<template>
    <div class="modal-overlay">
        <transition name="modal-expand">
            <div v-if="isVisible" class="products-modal" @click.stop>
                <div class="modal-content" @click.stop> <!-- stop the click event from propagating to the overlay -->
                    <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />>
                    <h2>Create a new Password</h2>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="password-input">
                                        <input :type="showPassword ? 'text' : 'password'" class="form-control rounded"
                                            id="password" name="password" placeholder="Create Password"
                                            v-model="newUser.password" />
                                        <font-awesome-icon class="eye-icon"
                                            :icon="['far', showPassword ? 'eye' : 'eye-slash']"
                                            @click="toggleShowPassword" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="form-group">
                                        <input :type="showPassword ? 'text' : 'password'" class="form-control rounded"
                                            id="reenteredPassword" name="reenteredPassword"
                                            placeholder="Re-enter Password" v-model="newUser.reenteredPassword" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <button style="width: 40%;" class="saveButton" @click="saveButton">Save</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
                    <div v-if="errorMessage">{{ errorMessage }}</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            users: [],
            newUser: {
                password: '',
                reenteredPassword: '',
            },
            showPassword: false,
            errorMessage: '',
            showAlert: false,
            isVisible: false,
        };
    },

    mounted() {
        this.isVisible = true;
        this.fetchData();
        window.addEventListener('show-alert', this.handleShowAlert);
    },
    beforeUnmount() {
        window.removeEventListener('show-alert', this.handleShowAlert);
    },


    methods: {
        async fetchData() {
            try {
                const token = localStorage.getItem('token');
                const headers = { Authorization: `Bearer ${token}` };
                const user_id = localStorage.getItem('user_id');

                let response = await axios.get(`/api/users/${user_id}`, { headers });

                this.users = response.data;
                console.log(response.data);

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        },

        close() {
            this.$emit('close');
            location.reload();
        },
        async saveButton() {
            // Check if values are set before making the API call
            if (this.newUser.password) {
                if (this.newUser.password !== this.newUser.reenteredPassword) {
                    this.errorMessage = 'Passwords do not match';
                    this.showAlert = true;
                    return;
                }
                try {
                    const token = localStorage.getItem('token');
                    const headers = { Authorization: `Bearer ${token}` };
                    const user_id = localStorage.getItem('user_id');
                    console.log(this.users);
                    const data = {
                        first_name: this.users.first_name,
                        last_name: this.users.last_name,
                        email: this.users.email,
                        role: this.users.role,
                        category: this.users.category,
                        license_no: this.users.license_no,
                        date_of_birth: this.users.date_of_birth,
                        place_of_birth: this.users.place_of_birth,
                        password: this.newUser.password
                    };
                    console.log("data", data);
                    const response = await axios.put(`/api/users/${user_id}`, data, { headers });

                    console.log(response);
                    if (response.status === 200) {
                        window.alert('Password updated Successfully');

                        this.$router.push('/trainee-home');
                    } else {
                        window.dispatchEvent(new CustomEvent('show-alert', { detail: "Password update failed" }));
                    }
                } catch (error) {
                    console.error("There was an error with updating the password:", error);
                    if (error.isOffline === true) {
                        return;
                    }
                }
            } else {
                console.error("Please enter a password.");
            }
        },
        toggleShowPassword() {
            this.showPassword = !this.showPassword;
        },

    },

};

</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.products-modal {
    background-color: #fff;
    max-width: min(90%, 900px);
    min-height: 30%;
    min-width: min(40%, 400px);
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    position: relative;
    display: block;
    z-index: 1001;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.modal-content {
    position: relative;
    max-height: 90vh;
    overflow-y: auto;
    padding: 15px;
    border: 1px solid #dddddd;
    border-radius: 3px;
}

.saveButton {
    background-color: #0a407a;
    color: #ffffff;
    padding: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: auto;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    align-self: center;
}

.eye-icon {
    position: absolute;
    top: 74px;
    right: 20px;
    cursor: pointer;
    color: grey;
}

input[type="text"],
input[type="password"] {
    width: 100%;
    margin-bottom: 20px;
    height: 40px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

h2 {
    margin-bottom: 1.5rem;
}

</style>